import React from "react";
import Navigation from "@/components/Navigation";
import Hero from "@/components/Hero";
import Services from "@/components/Services";
import About from "@/components/About";
import Approach from "@/components/Approach";
import Testimonials from "@/components/Testimonials";
import BookCall from "@/components/BookCall";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import { Toaster } from "@/components/ui/toaster";

function App() {
  return (
    <div className="App bg-brand-cream text-brand-ink font-sans overflow-x-hidden">
      <Navigation />
      <main>
        <Hero />
        <Services />
        <About />
        <Approach />
        <Testimonials />
        <BookCall />
        <Contact />
      </main>
      <Footer />
      <Toaster />
    </div>
  );
}

export default App;
